import posthog from 'posthog-js';

// Initialize with project API key (use env var REACT_APP_POSTHOG_KEY)
// If no key, PostHog calls are no-ops (posthog-js handles gracefully when not inited)

export const analytics = {
  init() {
    if (process.env.REACT_APP_POSTHOG_KEY) {
      posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
        api_host: 'https://app.posthog.com',
        capture_pageview: false, // we do it manually
        persistence: 'localStorage',
        autocapture: false,
      });
    }
  },

  identify(userId: string, traits?: Record<string, any>) {
    if (process.env.REACT_APP_POSTHOG_KEY) {
      posthog.identify(userId, traits);
    }
  },

  track(event: string, properties?: Record<string, any>) {
    if (process.env.REACT_APP_POSTHOG_KEY) {
      posthog.capture(event, properties);
    }
  },

  page(pageName: string, properties?: Record<string, any>) {
    if (process.env.REACT_APP_POSTHOG_KEY) {
      posthog.capture('$pageview', { page: pageName, ...properties });
    }
  },

  reset() {
    if (process.env.REACT_APP_POSTHOG_KEY) {
      posthog.reset();
    }
  },
};
